import { LiveReactionEmojiType } from "@/types/graphql/site.generated";

/** Набор, пока партнёр не выбрал свой (как на сервере). */
export const DEFAULT_LIVE_REACTION_EMOJIS: readonly LiveReactionEmojiType[] = [
  LiveReactionEmojiType.HeartType,
  LiveReactionEmojiType.FireType,
  LiveReactionEmojiType.LaughType,
  LiveReactionEmojiType.ClapType,
  LiveReactionEmojiType.WowType,
  LiveReactionEmojiType.PartyType,
];

/** Сервер знает только значения enum, картинку рисует витрина. */
export const LIVE_REACTION_EMOJI: Record<LiveReactionEmojiType, string> = {
  [LiveReactionEmojiType.HeartType]: "❤️",
  [LiveReactionEmojiType.FireType]: "🔥",
  [LiveReactionEmojiType.LaughType]: "😂",
  [LiveReactionEmojiType.ClapType]: "👏",
  [LiveReactionEmojiType.WowType]: "😮",
  [LiveReactionEmojiType.PartyType]: "🎉",
  [LiveReactionEmojiType.HeartEyesType]: "😍",
  [LiveReactionEmojiType.AngryType]: "😡",
  [LiveReactionEmojiType.SadType]: "😢",
  [LiveReactionEmojiType.ThumbsUpType]: "👍",
  [LiveReactionEmojiType.ThumbsDownType]: "👎",
  [LiveReactionEmojiType.MuscleType]: "💪",
  [LiveReactionEmojiType.SoccerType]: "⚽",
  [LiveReactionEmojiType.BoxingType]: "🥊",
  [LiveReactionEmojiType.TrophyType]: "🏆",
  [LiveReactionEmojiType.MindBlownType]: "🤯",
};

export const LIVE_REACTION_LABEL_KEYS: Record<LiveReactionEmojiType, string> = {
  [LiveReactionEmojiType.HeartType]: "liveReactions.emoji.heart",
  [LiveReactionEmojiType.FireType]: "liveReactions.emoji.fire",
  [LiveReactionEmojiType.LaughType]: "liveReactions.emoji.laugh",
  [LiveReactionEmojiType.ClapType]: "liveReactions.emoji.clap",
  [LiveReactionEmojiType.WowType]: "liveReactions.emoji.wow",
  [LiveReactionEmojiType.PartyType]: "liveReactions.emoji.party",
  [LiveReactionEmojiType.HeartEyesType]: "liveReactions.emoji.heartEyes",
  [LiveReactionEmojiType.AngryType]: "liveReactions.emoji.angry",
  [LiveReactionEmojiType.SadType]: "liveReactions.emoji.sad",
  [LiveReactionEmojiType.ThumbsUpType]: "liveReactions.emoji.thumbsUp",
  [LiveReactionEmojiType.ThumbsDownType]: "liveReactions.emoji.thumbsDown",
  [LiveReactionEmojiType.MuscleType]: "liveReactions.emoji.muscle",
  [LiveReactionEmojiType.SoccerType]: "liveReactions.emoji.soccer",
  [LiveReactionEmojiType.BoxingType]: "liveReactions.emoji.boxing",
  [LiveReactionEmojiType.TrophyType]: "liveReactions.emoji.trophy",
  [LiveReactionEmojiType.MindBlownType]: "liveReactions.emoji.mindBlown",
};

export const PHRASES_ICON = "💬";
